module.exports = __webpack_public_path__ + "img/tc10.b257004f.png";